import { z } from 'zod';

export const adjudicationFilterValidator = z.object({
  status: z.array(z.string()).default([])
});
